var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.emailTemplate)?_c('span',[_vm._v(_vm._s(_vm._f("ififnot")(_vm.condition.mustBe))+" label '"+_vm._s(_vm.emailTemplate.name.substring(0, 35))+"'")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }